export const SpecialMailLogic: Record<string, {
    onRead: () => void;
}> = {
    "INTRODUCTION": {
        onRead: () => {
            console.log("Read introduction email!");
        }
    }
}